import CartProducts from "../../components/cartProducts/cartproducts"
import PageAdress from "../../components/pageAdress/pageAdress"
import "./cart.css"

function Cart(){
    return(
        <div className="cart">
            <div className="cart-container">
                <PageAdress data={"سبد خرید"} data2={"تایین آدرس"} data3={"درگاه پرداخت"}/>
                <CartProducts/>
            </div>
        </div>
    )
}

export default Cart;